import db from "../../utils/firebase.config";
import "./style.css";
import { collectionGroup, getDocs, query, where } from "firebase/firestore";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const form = useRef(null);
  const [messageError, setMessageError] = useState("");
  const [validateIsNumber, setValidateIsNumber] = useState(false);
  const [ifBlankBox, setIfBlankBox] = useState(false);
  const navigate = useNavigate();

  const setNumber = (dato) => {
    let valoresAceptados = /^[0-9]+$/;
    if (dato.match(valoresAceptados) && dato.length === 10) {
      setValidateIsNumber(false);
      setMessageError("");
    } else {
      setValidateIsNumber(true);
      setMessageError("Introduzca solo números (10 dígitos)");
    }
    if (dato === "") {
      setValidateIsNumber(false);
    }
  };

  const findNumber = async (e) => {
    e.preventDefault();
    setIfBlankBox(false);

    const newForm = new FormData(form.current);
    const Data = { numberForm: newForm.get("numberForm") };

    const guessQuery = query(
      collectionGroup(db, "guess"),
      where("mobile", "==", Data.numberForm)
    );
    const querySnapshot = await getDocs(guessQuery);

    if (querySnapshot.empty) {
      setMessageError("No se encontró número");
      setIfBlankBox(true);
      return;
    }

    if (querySnapshot.size > 1) {
      setMessageError(
        "Número duplicado detectado. Contacta al administrador para corregir la base de datos."
      );
      setIfBlankBox(true);
      return;
    }

    const guestDoc = querySnapshot.docs[0];
    const invitationId = guestDoc.ref.parent.parent?.id;
    const guestData = guestDoc.data();

    if (!invitationId || !guestData?.slug) {
      setMessageError("No se pudo resolver la invitación para este número");
      setIfBlankBox(true);
      return;
    }

    form.current.reset();
    navigate(`/invitacion/${guestData.slug}/${invitationId}`);
  };

  return (
    <section id="login">
      <div className="login-card" data-aos="fade-up">

        <div className="login-monogram">L &amp; M</div>
        <div className="login-rule"></div>
        <h2 className="login-title">Invitación Personal</h2>
        <p className="login-subtitle">
          Ingresa tu número de teléfono<br />para acceder a tu invitación
        </p>

        <form onSubmit={findNumber} ref={form} className="login-form">
          <input
            type="text"
            name="numberForm"
            inputMode="numeric"
            maxLength="10"
            minLength="10"
            autoComplete="on"
            className="login-input"
            placeholder="10 dígitos"
            onChange={(e) => setNumber(e.target.value)}
          />

          {messageError && (
            <p className="login-error">{messageError}</p>
          )}

          <button type="submit" className="login-button shrink-on-hover-button">
            Entrar
          </button>
        </form>

      </div>
    </section>
  );
};

export default Login;
